import pie from './pie'

export default {
  pie
}